import { useMessagesQuery } from './useConversationMessages'

/**
 * Get last message of conversation from the react-query cache
 */
export default function useCachedConversationLastMessage(conversationId) {
  // Just read the cache without triggering a request if the conversation is not loaded
  const { data } = useMessagesQuery(conversationId, {
    enabled: false,
    select: (data) => {
      const lastPage = data.pages[0]
      return lastPage[lastPage.length - 1]
    },
  })

  return data
}
